import { emojiMap } from 'smile2emoji';

const replaceLastWordWithEmoji = (text) => {
  const lastWord = text.match(/(\S+)(?:\s)*$/)?.pop().trim();
  if (lastWord) {
    const possibleEmoji = emojiMap[lastWord];
    if (possibleEmoji) {
      const n = text.lastIndexOf(lastWord);
      const textWithEmoji = text.slice(0, n) + text.slice(n).replace(lastWord, possibleEmoji).trim();
      return textWithEmoji;
    }
  }
  return text;
};

export default replaceLastWordWithEmoji;
